import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/topic/sitemap/pageContext';

export const TopicSitemapErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Topic sitemap page (error: ${error})`);
};
